<template lang="pug">
  v-layout.justify-center(:class="{ 'choice-load': isChoice }")
    v-flex.grow-0.margin-border(v-if="selectedCategory && config")
      v-layout.pb-2.align-center.justify-end
        .title.icone Icone
        .title.popin Etiquette
        .title.link Lien externe
      v-layout.column.justify-start.margin-rigth
        v-flex.override-flex(v-for="layer in orderedIcons" :key="layer.name")
          v-layout.align-center.justify-space-between.margin-bot
            v-img(
              v-if="layer.icon" :height="32" :max-width="32" :width="32" :aspect-ratio="1"
              :src="'/v1/static/icons/' + layer.icon + '.png'"
            )
            p.v-label.theme--light {{ layer.name }}
            <div style="display: inline-flex;align-items: baseline;margin-bottom: 5px;">
            v-checkbox.mt-0.pt-2.pb-1(
              data-test="layer"
              hide-details
              :color="color"
              :input-value="!config.icons || !disabled.includes(layer.id)"
              @change="(value) => { changeLayer(value, layer.id, 'icons'); changeLayer(value, layer.id, 'popin'); changeLayer(value, layer.id, 'link');  }"
            )
            ToggleButton(
              :class="{ 'disable': disabled.includes(layer.id) }"
              :defaultState="!disabled.includes(layer.id) && !(config.popin.disabled?config.popin.disabled.includes(layer.id):false)"
              :disabled="disabled.includes(layer.id)"
              :id="layer.id + '_popin'"
              :input-value="!disabled.includes(layer.id) && !(config.popin.disabled?config.popin.disabled.includes(layer.id):false)"
              @change="(value) => { changeLayer(value, layer.id, 'popin'); changeLayer(value, layer.id, 'link'); }"
            )
            ToggleButton(
              :class="{ 'disable': (disabled.includes(layer.id) || (config.popin.disabled?config.popin.disabled.includes(layer.id):false)), 'invisible': ['welcome_to_the_farm','market', 'information_office', 'small_city_with_character', 'most_beautiful_village'].includes(layer.id) }"
              :defaultState="!disabled.includes(layer.id) && !(config.popin.disabled?config.popin.disabled.includes(layer.id):false) && !(config.link.disabled?config.link.disabled.includes(layer.id):false)"
              :disabled="(config.popin.disabled?config.popin.disabled.includes(layer.id):false) || disabled.includes(layer.id)"
              :id="layer.id + '_link'"
              :input-value="!disabled.includes(layer.id) && !(config.link.disabled?config.link.disabled.includes(layer.id):false)"
              @change="(value) => { changeLayer(value, layer.id, 'link'); }"
            )
            </div>
</template>

<script>
import ToggleButton from '../RcToggleButton.vue';
import mixin from '@/mixins/Rc.mixin.vue';

// .subheading.underline.click.mr-3(@click="changeAll(true)") Tout cocher
// .subheading.underline.click.mr-3(@click="changeAll(false)") Tout décocher

export default {
  components: {
    ToggleButton,
  },
  props: {
    config: Object,
  },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      selectedCategory: null,
      disabled: [],
    };
  },
  watch: {
    config() {
      this.transientParams = this.filterConfig(this.config);
    },
  },
  beforeMount() {
    this.$store.dispatch('layers/getCategories').then(() => {
      this.categories.forEach((category) => {
        if (category.name === 'Partenaires') this.selectedCategory = category;
      });
    });
    this.checkedNames = this.config.icons.disabled;
  },
  methods: {
    changeAll(value) {
      if (this.selectedCategory.icons) {
        // eslint-disable-next-line array-callback-return
        this.selectedCategory.icons.map((it) => {
          this.changeLayer(value, it.id, 'icons');
          this.changeLayer(value, it.id, 'popin');
          this.changeLayer(value, it.id, 'link');
        });
      }
    },
    changeLayer(value, id, type) {
      this.loading = true;
      if (this.config[type].disabled === undefined) {
        this.config[type].disabled = [];
      }
      let beforeLayers = this.config[type].disabled;
      if (!value) {
        if (!beforeLayers.includes(id)) beforeLayers.push(id);
      } else {
        beforeLayers = this.config[type].disabled.filter(x => x !== id);
      }
      if (type === 'icons') this.checkedNames = beforeLayers;
      this.config[type].disabled = beforeLayers;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
    },
  },
  computed: {
    checkedNames: {
    //  v-model="checkedNames"
    //  v-bind:value="layer.id"
      get() {
        return this.selectedCategory.icons.map(it => it.id);
      },
      set(newValue) {
        this.disabled = newValue;
      },
    },
    categories() {
      return this.$store.state.layers.categories;
    },
    orderedIcons() {
      if (this.selectedCategory.icons) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.selectedCategory.icons.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      }
      return this.selectedCategory.icons;
    },
    isChoice() {
      return this.$route.query.context === 'choice';
    },
    color() {
      return this.isChoice ? '#e75239' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
  .override-flex {
    flex: 0!important;
  }
  .pl-5 {
    padding-right: 48px!important;
  }
  p {
    margin: 0 15px 0 0 !important;
    left: 15px;
    position: relative;
    -webkit-box-flex: 100;
    -ms-flex: 100 1 auto;
    flex: 10 1 auto;
    /* align-self: center;*/
  }
  .v-input {
    padding: 4px 10px;
    transform: translateY(0%);
    margin-left: 20px;
  }
  .title{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #e7523e;
    font-size: 17px !important;
    padding: 9px;
  }
  .icone {
    margin: 0 5px;
  }
  .link {
    width: min-content;
    text-align: center;
    padding-left: 10px;
  }
  .align-center {
    align-items: center;
  }
  .margin-border {
    margin-left: 15px;
  }
  .margin-rigth {
    margin-right: 10px;
  }
  .margin-bot {
    margin-bottom: 15px;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .column {
    width: fit-content;
  }
  .toggle__button {
    /*padding: 15px;
    margin-bottom: 2px;
    margin-left: 15px;*/
    align-self: center;
    margin-top: 5px;
    padding: 0 15px;
    margin-left: 15px;
  }

  .invisible {
    visibility: hidden;
  }

  /* Track (Disabled Off) */
  /*.disable > span {
    background: #C8C8C8 !important;
    box-shadow: 0px 1px 1px 0px #C0C0C0 !important;
  }*/
  /* Thumb (Disabled Off) */
  /*.disable > .toggle__switch::after {
    background: #EEEEEE !important;
    box-shadow: 0px 1px 1px 1px #D7D7D7 !important;
  }
  .disable {
    cursor: unset !important;
  }*/
</style>
